import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_authenticated/_organization/events/$eventUuid/"
)({
  component: function EventDetailIndexRoute() {
    const { eventUuid } = Route.useParams()
    return (
      <Navigate
        to="/events/$eventUuid/$tabKey"
        params={{ eventUuid, tabKey: "overview" }}
        replace
      />
    )
  },
})
